import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Distribution tags (dist-tags) are human-readable labels that you can use to organize and label different versions of packages you publish. dist-tags supplement `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic versioning`}</a>{`. In addition to being more human-readable than semantic version numbering, tags allow publishers to distribute their packages more effectively.`}</p>
    <p>{`For more information, see the `}<a parentName="p" {...{
        "href": "/cli/dist-tag"
      }}><inlineCode parentName="a">{`dist-tag`}</inlineCode>{` CLI documentation`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Since dist-tags share a namespace with semantic versions, avoid dist-tags that conflict with existing version numbers. We recommend avoiding dist-tags that start with a number or the letter "v".`}</p>
    </Note>
    <h2>{`Publishing a package with a dist-tag`}</h2>
    <p>{`By default, running `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` will tag your package with the `}<inlineCode parentName="p">{`latest`}</inlineCode>{` dist-tag. To use another dist-tag, use the `}<inlineCode parentName="p">{`--tag`}</inlineCode>{` flag when publishing.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the root directory of your package.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/package
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the following command, replacing `}<inlineCode parentName="p">{`<tag>`}</inlineCode>{` with the tag you want to use:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm publish --tag <tag>
`}</code></pre>
      </li>
    </ol>
    <h3>{`Example`}</h3>
    <p>{`To publish a package with the "beta" dist-tag, on the command line, run the following command in the root directory of your package:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm publish --tag beta
`}</code></pre>
    <h2>{`Adding a dist-tag to a specific version of your package`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the root directory of your package.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/package
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the following command, replacing `}<inlineCode parentName="p">{`<package_name>`}</inlineCode>{` with the name of your package, `}<inlineCode parentName="p">{`<version>`}</inlineCode>{` with your package version number, and `}<inlineCode parentName="p">{`<tag>`}</inlineCode>{` with the distribution tag:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm dist-tag add <package-name>@<version> [<tag>]
`}</code></pre>
      </li>
    </ol>
    <h3>{`Example`}</h3>
    <p>{`To add the "stable" tag to the 1.4.0 version of the "example-package" package, you would run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm dist-tag add example-package@1.4.0 stable
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      